import { useLocation } from 'react-router-dom';
import { NAV_ITEMS } from '../navigation.js';
import { EmptyState } from '../components/NoData.js';

const MILESTONE_BY_PATH: Record<string, string> = {
  '/campaigns': 'Milestone 6 — Google Ads read integration',
  '/keywords': 'Milestone 9 — keyword and search term intelligence',
  '/search-terms': 'Milestone 9 — keyword and search term intelligence',
  '/geography': 'Milestone 10 — geographic intelligence',
  '/linkedin': 'Milestone 14 — LinkedIn integration',
  '/landing-pages': 'Milestone 11 — landing page intelligence',
  '/conversions': 'Milestone 7 — attribution engine',
  '/pipeline': 'Milestone 5 — HubSpot integration',
  '/budget': 'Milestone 12 — recommendation engine',
  '/recommendations': 'Milestone 12 — recommendation engine',
  '/analyst': 'Milestone 13 — AI Analyst',
  '/audit': 'Milestone 12 — recommendation engine',
  '/settings': 'Milestone 3 — application shell',
};

export function Placeholder(): JSX.Element {
  const { pathname } = useLocation();
  const item = NAV_ITEMS.find((i) => i.path === pathname);
  const milestone = MILESTONE_BY_PATH[pathname] ?? 'a later milestone';

  return (
    <EmptyState title="Not built yet" tag="Foundation">
      This screen will answer: <em>{item?.question}</em> It is delivered by {milestone}. Until then it
      shows nothing rather than placeholder figures, because a dashboard that invents numbers is worse
      than no dashboard.
    </EmptyState>
  );
}
